export const MOBILE_REGEX = /^(\+98|98|0)?9\d{9}$/;
export const URL_REGEX = /(\b(?:https?:\/\/|www\.)\S+\b)/gi;
export const COMMA_CHARACKTERS = /[,‚،‘‚’´‘’]/g;
export const MATCH_OPERATORS = /[*+!]/g;
export const MATCH_KEYWORD_OPERATORS = /(?:^|[\s()])(?:AND|OR|NOT)(?=$|[\s()])/;
export const WEBSITE_URL_REGEX =
  /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/;
